import { createContext } from "react";
const RadioGroupContext = createContext(
  null
);
const RadioItemContext = createContext(null);
export {
  RadioGroupContext,
  RadioItemContext
};
